import HashWorker from 'worker-loader!@/worker/hash.worker';
import type { Hashes } from '@/worker/hash.worker';
import runWorker from './runWorker';

export default {
    async calculateBoth(binaryData: Uint8Array, signal?: AbortSignal) {
        const result = await runWorker<{ hashes: Hashes }>(new HashWorker(), {
            image: binaryData,
            hashTypes: { data: true, perceptual: true },
        }, [binaryData.buffer], signal);
        return { data: result.hashes.data!, perceptual: result.hashes.perceptual! };
    },
};
